module.exports = __webpack_public_path__ + "img/FreshPay logo_revised (1).56b46bd8.png";